import { SVGProps } from "react";

export const MagnifierIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.28 19.43"
    {...props}
  >
    <path d="M14.59,13.53c1.22-1.5,1.91-3.41,1.91-5.28C16.5,3.7,12.8,0,8.25,0S0,3.7,0,8.25s3.7,8.25,8.25,8.25c1.87,0,3.78-.69,5.28-1.91l4.84,4.84.9-1.2-4.69-4.69ZM8.25,1.5c3.79,0,6.75,2.96,6.75,6.75s-2.96,6.75-6.75,6.75S1.5,12.04,1.5,8.25,4.46,1.5,8.25,1.5Z" />
  </svg>
);
